import { action, makeObservable, observable } from 'mobx';
import { ApiReq, emptyValue } from 'src/api';
import { ContainerItem, UpdatedContainerResponse } from 'src/api/api-types/containers';
import { ContainersApi } from 'src/api/containers';
import { ItemType } from 'src/types';

export class ContainerModification {
  api = new ContainersApi({prefix: ''});

  readonly id: number;
  @observable wasteMaterialTypes: ItemType[] = []
  @observable hdwpf: boolean = false;

  @observable.ref updateContainerReq: ApiReq<UpdatedContainerResponse> = emptyValue;

  constructor({ id, wasteMaterialTypes, hdwpf }: Pick<ContainerItem, 'id' | 'wasteMaterialTypes' | 'hdwpf'>) {
    makeObservable(this)
    this.id = id;
    this.wasteMaterialTypes = wasteMaterialTypes;
    this.hdwpf = hdwpf;
  }

  @action setWasteMaterialTypes = (items: ItemType[]) => this.wasteMaterialTypes = items;

  @action setHDWPF = (hdwpf: boolean) => this.hdwpf = hdwpf;

  @action updateContainer = async () => {
    this.updateContainerReq = this.api.updateContainer({
      id: this.id,
      wasteMaterialTypes: this.wasteMaterialTypes,
      hdwpf: this.hdwpf
    })

    await this.updateContainerReq
    return this.updateContainerReq
  }
}
